import React from "react";
import { Icon } from "@iconify/react";
export function Header({ expanded = false, onToggleState }) {
    return (React.createElement("div", { className: "w-full flex justify-between" },
        React.createElement("div", { className: "flex items-center gap-2" },
            React.createElement("div", { className: "text-lg my-auto" }, "Delivery Info"),
            React.createElement("div", { title: "Select your delivery address" },
                React.createElement(Icon, { icon: "material-symbols:exclamation", width: "20", height: "20", className: "rounded-full border border-black" }))),
        React.createElement("button", { onClick: onToggleState },
            React.createElement("div", null, expanded ? React.createElement(Icon, { icon: "lucide:chevron-down", width: "24", height: "24" }) : React.createElement(Icon, { icon: "lucide:chevron-right", width: "24", height: "24" })))));
}
